export default "__VITE_ASSET__Cvxw1Tnu__"